import { cn } from "../../lib/utils";

type Props = {
  num: number;
  title: string;
  subtitle?: string;
  duration?: string;
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
};

/** Shared numbered drill card. Lives in a 2×2 grid in both bodies. The subtitle
 *  is hidden on the compact mobile layout (`hidden sm:block`). */
export function DrillCard({ num, title, subtitle, duration, selected, onSelect, disabled }: Props) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      disabled={disabled}
      className={cn(
        "w-full text-left rounded-[var(--radius)] border-2 p-4 flex gap-3 items-start transition-[border-color,background-color,transform] duration-150 ease-out",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-60",
        selected
          ? "border-[var(--accent)] bg-[var(--accent-soft)]"
          : "border-[var(--border)] bg-[var(--panel)] enabled:hover:border-[var(--border-strong)] enabled:hover:-translate-y-px",
      )}
    >
      <span
        aria-hidden
        className={cn(
          "grid place-items-center w-9 h-9 rounded-lg flex-none font-display font-semibold transition-colors",
          selected ? "bg-[var(--accent)] text-white" : "bg-[var(--accent-soft)] text-[var(--accent)]",
        )}
      >
        {num}
      </span>
      <span className="min-w-0">
        <span className="block text-sm font-semibold text-[var(--ink)]">{title}</span>
        {subtitle ? (
          <span className="hidden sm:block text-[13px] text-[var(--ink-muted)] leading-snug">
            {subtitle}
          </span>
        ) : null}
        {duration ? (
          <span className="mt-1.5 inline-block font-mono-badge text-[11px] text-[var(--ink-faint)]">
            {duration}
          </span>
        ) : null}
      </span>
    </button>
  );
}
